import React, { useEffect } from 'react';
import useRematchDispatch from '../../../hooks/useRematchDispatch';
import { useTracking } from '../../../hooks/useTracking';
import analytics from '../../../modules/analytics';
import type { IRootDispatch } from '../../../store/models';
import withStore from '../../withStore';
import type { CelebrationModalProps } from './CelebrationModal';
import CelebrationModal from './CelebrationModal';

export type CelebrationModalContainerProps = {
  celebrationProps: CelebrationModalProps,
  actionPrefix: string,
  providerId: string | number,
  cta: {
    route?: string,
    tracking: string,
    routeParams?: object,
  },
};

export type CelebrationModalContainerInjectedProps = {
  close: () => void;
};

const CelebrationModalContainer: React.FC<
CelebrationModalContainerProps&CelebrationModalContainerInjectedProps
> = ({
  celebrationProps, actionPrefix, providerId, cta, close,
}) => {
  const { go } = useRematchDispatch((dispatch: IRootDispatch) => ({
    go: cta.route
      ? () => dispatch.route.go({
        route: cta.route,
        params: { providerId, ...cta.routeParams },
        notify: true,
      })
      : close,
  }));

  const onClick = useTracking(() => {
    go();
    if (close && typeof close === 'function') {
      close();
    }
  }, {
    [`${actionPrefix}_${cta.tracking}`]: {
      providerId,
    },
  });

  const onClose = useTracking(close, {
    [`${actionPrefix}_dismissed`]: {
      providerId,
    },
  });

  useEffect(() => {
    analytics.track(`${actionPrefix}_view`, {
      providerId,
    });
  }, [actionPrefix, providerId]);

  const passThroughProps: CelebrationModalProps = {
    ...celebrationProps,
    button: { ...celebrationProps.button, onClick },
    close: onClose,
    testIdPrefix: actionPrefix,
    childProps: {
      providerId,
    },
  };

  return (<CelebrationModal {...passThroughProps} />);
};

export default withStore(CelebrationModalContainer);
